<template>
  <div class="m-card">
    <div style="display: flex; justify-content: flex-end">
      <vs-button
        radius
        color="gray"
        type="flat"
        icon="settings"
        class="btn-setting"
        @click="$bvModal.show('setting-machine')"
      ></vs-button>
      <b-modal
        id="setting-machine"
        v-model="modalShow"
        centered
        title="BootstrapVue"
        ok-title="Submit"
        ok-variant="success"
        @ok="submit"
      >
        <template #modal-header>
          <div>
            <h4 style="color: #32c040">Machine Infomation Status</h4>
          </div>
        </template>
        <div
          v-for="(list, i) in infoNew"
          :key="i"
          style="display: flex; margin-bottom: 5px"
        >
          <div v-if="i != 'id'" style="display: flex; align-items: center">
            <label
              :for="'machine_' + i"
              style="width: 130px; text-align: end; margin-right: 5px"
              >{{ label[i] }} :</label
            >
            <vs-input
              type="text"
              :id="'machine_' + i"
              v-model="infoNew[i]"
              style="border-radius: 10px; padding: 2px; color: #000"
              :disabled="i == 'serial_id'"
            />
          </div>
        </div>
      </b-modal>
    </div>
    <img
      style="width: 60%"
      :src="imgInfo"
      alt=""
    />
    <div class="content">
      <ul>
        <div v-for="(list, i) in info" :key="i">
          <li v-if="i != 'id'">
            <b>{{ label[i] }} : </b>
            <span v-if="i == 'line'" style="font-size: 2rem; font-weight: bold">
              {{ list }}
            </span>
            <span v-else>{{ list }}</span>
          </li>
        </div>
        <!-- <li>
          <b>{{ label.line }} : </b>
          <span style="font-size: 2rem; font-weight: bold">
            {{ info.line }}
          </span>
        </li>
        <li>
          <b>{{ label.serial_id }} : </b>
          <span>
            {{ info.serial_id }}
          </span>
        </li>
        <li>
          <b>{{ label.name }} : </b>
          <span>
            {{ info.name }}
          </span>
        </li>
        <li>
          <b>{{ label.brand }} : </b>
          <span>
            {{ info.brand }}
          </span>
        </li>
        <li>
          <b>{{ label.model }} : </b>
          <span>
            {{ info.model }}
          </span>
        </li>
        <li>
          <b>{{ label.officer }} : </b>
          <span>
            {{ info.officer }}
          </span>
        </li>
        <li>
          <b>{{ label.phone }} : </b>
          <span>
            {{ info.phone }}
          </span>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
  },
  data() {
    return {
      modalShow: false,
      info: {},
      infoNew: {
        line: "ไลน์เครื่องจักร/แผนก",
        serial: "เลขรหัสประจำเครื่อง",
        name: "ชื่อเครื่องจักร",
        brand: "ยี่ห้อเครื่องจักร",
        model: "รุ่นเครื่องจักร",
        officer: "ผู้รับผิดชอบ",
        phone: "Tel.",
      },
      label: {
        line: "ไลน์เครื่องจักร/แผนก",
        serial: "เลขรหัสประจำเครื่อง",
        name: "ชื่อเครื่องจักร",
        brand: "ยี่ห้อเครื่องจักร",
        model: "รุ่นเครื่องจักร",
        officer: "ผู้รับผิดชอบ",
        phone: "Tel.",
      },
    };
  },
  mounted() {
    this.getInfoMachine();
  },
  computed:{
    imgInfo(){
      try {
        return require('@/assets/images/CPF/'+this.info.name.split(' ')[0]+'.png')
      } catch (error) {
        return require('@/assets/images/hino element/machine.gif')
      }
    }
  },
  methods: {
    async submit() {
      try {
        console.log("update");
        // console.log(this.infoNew);
        let res = await this.$API.put(`CPF-updateinfo`, this.infoNew);
        // console.log("CPF-updateinfo", res);
        if (res.data.status == true) {
          this.getInfoMachine();
          this.$vs.notify({
            time: 4000,
            title: "Edit Success",
            text: "You edit information machine success",
            color: "success",
            icon: "done",
            position:'top-center'
          });
        }else{
          this.$vs.notify({
            time: 4000,
            title: "Edit Failed",
            text: "You edit information machine failed",
            color: "danger",
            icon: "warning",
            position:'top-center'
          });
        }
      } catch (error) {
        console.log(error);
        this.$vs.notify({
            time: 4000,
            title: "Edit Failed",
            text: "You edit information machine failed",
            color: "danger",
            icon: "warning",
            position:'top-center'
          });
      }
    },
    async getInfoMachine() {
      try {
        let res = await this.$API.get(`CPF-getinfo/${this.id}`);
        console.log("cpf/getmachine/", res);
        this.info = res.data.message[0];
        console.log(this.info);
        for (const key in this.info) {
          this.infoNew[key] = this.info[key];
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.m-card {
  color: var(--text-color-2);
}
img {
  position: absolute;
  right: 0px;
  bottom: 5px;
  z-index: 1;
  opacity: 0.9;
}
.btn-setting {
}
.content {
  z-index: 2;
}
ul {
  list-style-type: none;
  li {
    margin-bottom: 1rem;
    font-size: 1rem;
  }
}
</style>